import React, { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import axios from "axios";

export const ProjectSideAnalytics = ({
  projectExist,
  setChartData,
  chartData,
  setSelectedIndex,
  selectedIndex,setSelectedAlias
}) => {
  const analyticsTabs = projectExist?.analytics?.analytics_activeTab || [];
  const rabiTaskId = projectExist?.analytics?.rabi_task_id;
  const kharifTaskId = projectExist?.analytics?.kharif_task_id;
  const [season, setSeason] = useState("");
  // console.log("projectExist",projectExist)
  useEffect(() => {
    if (kharifTaskId && rabiTaskId) {
      setSeason("Kharif");
    } else if (kharifTaskId) {
      setSeason("Kharif");
    } else if (rabiTaskId) {
      setSeason("Rabi");
    }
  }, [kharifTaskId, rabiTaskId]);

  const getTaskId = () => {
    if (season === "Kharif") return kharifTaskId;
    if (season === "Rabi") return rabiTaskId;
    return null;
  };

  useEffect(() => {
    // console.log("clock",season)

    const fetchData = async () => {
      // console.log("clock33",season)

      const taskId = getTaskId();
      if (!taskId) return;

      try {
        const response = await axios.get(
          `https://datapipeline-api.agrani.tech/task_details?taskId=${taskId}`
        );
        setChartData(response?.data?.data);
        // console.log("API data:", response?.data?.data);
      } catch (error) {
        console.error("Failed to fetch chart data:", error);
      }
    };

    if (season) {
      // setChartData(null);
      // setSelectedIndex(null);
      // console.log("clock22",chartData)
      fetchData();
    }
  }, [season]);

  const handleIndexSelect = (value,index) => {
    // console.log("index",index)
    // console.log("value", value);
    setSelectedIndex(value);
    setSelectedAlias(index.alias)
  };

  const clearFilters = () => {
    setSelectedIndex(null);
    setSelectedAlias(null)
    // setChartData(null);

  };
  // console.log("chartData", chartData);

  return (
    <Card>
      <CardBody style={{ padding: "1.8rem 2.5rem" }}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="card-title fw-bold text-primary mb-0">
            <i className="mdi mdi-filter-variant me-2" />
            Analytics
          </h5>
          {selectedIndex && (
            <button
              className="btn btn-sm p-1 px-2 border text-danger"
              onClick={clearFilters}
              title="Clear all filters"
              style={{
                fontSize: "0.85rem",
                borderRadius: "6px",
                borderColor: "#dc3545",
                color: "#dc3545",
                backgroundColor: "#fff",
              }}
            >
              Clear <i className="mdi mdi-close-circle fs-6" />
            </button>
          )}
        </div>

        <div className="mb-3">
          <label className="fw-semibold text-secondary">
            🌾 Select Season:
          </label>
          <div className="d-flex align-items-center gap-4 mt-2">
            {kharifTaskId && (
              <>
                <input
                  className="form-check-input"
                  type="radio"
                  name="season"
                  id="seasonKharif"
                  value="Kharif"
                  checked={season === "Kharif"}
                  onChange={(e) => setSeason(e.target.value)}
                />
                <label className="form-check-label" htmlFor="seasonKharif">
                  Kharif
                </label>
              </>
            )}
            {rabiTaskId && (
              <>
                <input
                  className="form-check-input"
                  type="radio"
                  name="season"
                  id="seasonRabi"
                  value="Rabi"
                  checked={season === "Rabi"}
                  onChange={(e) => setSeason(e.target.value)}
                />
                <label className="form-check-label" htmlFor="seasonRabi">
                  Rabi
                </label>
              </>
            )}
          </div>
        </div>

        {analyticsTabs.map((tab, tabIndex) => (
          <div key={tabIndex} className="mb-3">
            <h6 className="text-secondary fw-semibold mb-2">{tab.alias}</h6>
            {tab.indices.map((index, indexIdx) => (
              <div className="form-check mb-2" key={indexIdx}>
                <input
                  className="form-check-input"
                  type="radio"
                  name={`dynamicIndex-${tab.type}`}
                  id={`${tab.type}-${index.name}`}
                  value={index.name}
                  checked={selectedIndex === index.name}
                  onChange={() => handleIndexSelect(index.name,index)}
                />
                <label
                  className="form-check-label"
                  htmlFor={`${tab.type}-${index.name}`}
                >
                  {index.alias}
                </label>
              </div>
            ))}
          </div>
        ))}
      </CardBody>
    </Card>
  );
};
